






import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Stats',
  components: {},
})
export default class Stats extends Vue {
}
